export enum OrientationTypes {
  Bottom = 'Bottom',
  BottomLeft = 'BottomLeft',
  BottomRight = 'BottomRight',
  Center = 'Center',
  Left = 'Left',
  Right = 'Right',
  Top = 'Top',
  TopLeft = 'TopLeft',
  TopRight = 'TopRight'
}
